module.exports = __webpack_public_path__ + "img/rainy-4.c8cdb216.svg";